export const ESTADO_CUENTA_TITULARIDAD = {
  PENDING: 1,
  CONFIRMED: 2,
  REJECTED: 3,
  NORESPONSE: 4,
} as const

export type AccountStatusType =
  (typeof ESTADO_CUENTA_TITULARIDAD)[keyof typeof ESTADO_CUENTA_TITULARIDAD]
